import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { ExecuteOperationOnPipe, Form, ModelContext } from '@morningtrain/react-resources'
import EmailTemplateForm from 'pages/app/emailtemplates/smartviews/EmailTemplateForm'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'
import ConfirmFormChanges from 'support/pipelines/ConfirmFormChanges'
import { observable } from 'mobx'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'

export default function CreateEmailTemplateSmartview () {
  const footer = (
    <UI.ButtonWrap>
      <UI.SubmitButton>
        <Translation name='generic.save' />
      </UI.SubmitButton>
    </UI.ButtonWrap>
  )
  return (
    <Translator namespace='email_templates'>
      <Form route='api.email_templates.store' preventParentOperationRefresh>
        <ExecuteOperationOnPipe namespace='api' resourceName='email_templates' operationName='index' />
        <ResetSmartviewOnPipe />
        <Smartview size='2xl' footer={footer} header={<Translation name='titles.create' />}>
          <ModelContext.Provider value={observable.map()}>
            <ConfirmFormChanges />
            <EmailTemplateForm />
          </ModelContext.Provider>
        </Smartview>
      </Form>
    </Translator>
  )
}
